import React from 'react';
import classNames from 'classnames';

const DraftControllButton = (props)=> {

    const handleClick = () =>{
        if(props.inactive !== true) {
            props.onClick();
        }

    };

    const renderRedoSVG = ()=> {
        return (
        <svg
        preserveAspectRatio="xMidYMid" width="21.094" height="17.437" viewBox="0 0 21.094 17.437">
            <path fill="#FFFFFF" fillRule="evenodd"
                  d="M12.736,11.755 L12.151,10.904 L18.721,6.390 L9.729,6.389 C9.700,6.385 6.601,6.159 4.130,8.434 C2.074,10.329 1.030,12.795 1.030,16.934 L1.030,17.450 L-0.002,17.450 L-0.002,16.934 C-0.002,12.494 1.153,9.773 3.431,7.675 C6.231,5.097 9.669,5.347 9.772,5.358 L18.721,5.358 L12.151,0.845 L12.736,-0.007 L21.102,5.741 L21.102,6.007 L12.736,11.755 Z"
            />
        </svg>

        )

    };
    const renderUndoSVG = ()=> {
        return (
        <svg preserveAspectRatio="xMidYMid" width="21.094" height="17.437" viewBox="0 0 21.094 17.437">
            <path fill="#FFFFFF" fillRule="evenodd"
                  d="M20.064,17.450 L20.064,16.934 C20.064,12.795 19.021,10.329 16.964,8.434 C14.493,6.159 11.394,6.385 11.365,6.389 L2.373,6.390 L8.943,10.904 L8.358,11.755 L-0.008,6.007 L-0.008,5.741 L0.710,5.248 L0.710,5.248 L0.710,5.248 L8.358,-0.007 L8.943,0.845 L2.373,5.358 L11.323,5.358 C11.425,5.347 14.863,5.097 17.663,7.675 C19.941,9.773 21.096,12.494 21.096,16.934 L21.096,17.450 L20.064,17.450 Z"/>
        </svg>)

    };

    const renderSVG = ()=> {
        return props.type === "undo" ? renderUndoSVG() : renderRedoSVG();
    };

    const buttonClass = classNames({
        "rich-controlls": true,
        "-undo": props.type === "undo",
        "-redo": props.type === "redo",
        "-inactive" : props.inactive === true
    });


    return (
    <div className={buttonClass} onClick={handleClick}>
        <div className="rich-controlls__svg-wrapper">
            {renderSVG()}
        </div>
        <div className="rich-controlls__label">
            {props.label}
            <div className="rich-controlls__arrow"></div>
        </div>
    </div>
    )
};

export default DraftControllButton;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/DraftControllButton.js